import React, {useEffect} from "react";
import styles from "./category_container.module.css";
import { Link } from "react-router-dom";
import {ICategory} from "../../../services/model/Category";

interface Props {
    categories: ICategory[];
    activeCategory: string | null;
    isMobile: boolean;
    handleCategoryHover: (category: string) => void;
    handleCategoryClick: (category: string) => void;
}

const CategoryContainer: React.FC<Props> = (props) => {

    useEffect(() => {
        console.log("CategoryContainer>> ", "")
    }, []);

    return (
            <div
                className={`${styles.categories_container} ${
                    props.isMobile ? styles.slideLeft : ""
                }`}
            >
                <ul>
                    {props.categories.map((cat) => (
                        <li
                            key={cat.name}
                            onMouseEnter={() => props.handleCategoryHover(cat.name)}
                            onClick={() => props.handleCategoryClick(cat.name)}
                            className={props.activeCategory === cat.name ? styles.active : ""}
                        >
                            {props.isMobile ? (
                                <div className={styles.categoryWrapper}>
                                    <img src={cat.imageUrl} alt={cat.name} className={styles.categoryImage}/>
                                    <span>{cat.name}</span>
                                </div>
                            ) : (
                                <Link
                                    to={`/corals/${cat.name.toLowerCase()}`}
                                    style={{textDecoration: 'none', color: 'inherit'}}
                                    onClick={(e) => {
                                        // Desktop: force full page reload to close menu and show products
                                        if (!props.isMobile) {
                                            e.preventDefault();
                                            window.location.href = `/corals/${cat.name.toLowerCase()}`;
                                        }
                                    }}
                                >
                                    <div className={styles.categoryWrapper}>
                                        <img src={cat.imageUrl} alt={cat.name} className={styles.categoryImage}/>
                                        <span>{cat.name}</span>
                                    </div>
                                </Link>
                            )}

                            <span className={styles.arrow}>›</span>
                        </li>
                    ))}
                </ul>
            </div>
            );
            };

            export default CategoryContainer;
